import { JobMatchActionsModule } from "./jobMatchActions/job-match-actions.module";
import { ExternalNotesModule } from "./externalNotes/external-notes.module";
import { FourDotFivePhoneNumberModule } from "./fourDotFivePhoneNumber/four-dot-five-phone-number.module";
import { OverrideCandidateSuspensionModule } from "./overrideCandidateSuspension/override-candidate-suspension.module";
import { UserHeaderModule } from "./userHeader/user-header.module";
import { UserNotificationsModule } from "./userNotifications/user-notifications.module";
import { CompaniesModule } from "./companies/companies.module";
export const SharedModule = angular
    .module('shared', [
    JobMatchActionsModule,
    ExternalNotesModule,
    FourDotFivePhoneNumberModule,
    OverrideCandidateSuspensionModule,
    UserHeaderModule,
    UserNotificationsModule,
    CompaniesModule,
])
    .name;
//# sourceMappingURL=shared.module.js.map